import React from "react";
import "./Terms.css";

function Terms() {
  return (
    <div className="TodoTerms">
      <div className="TodoTerms-inner">
        <h1>利用規約（ToDo）</h1>
        <p className="muted">
          この利用規約（以下「本規約」）は、作田陽樹（以下「開発者」）が提供する
          ToDo（以下「本アプリ」）および関連サービス（以下「本サービス」）の利用条件を定めるものです。
          利用者は、本規約に同意のうえ本サービスを利用するものとします。
        </p>

        <h2>第1条（適用）</h2>
        <p>
          本規約は、利用者と開発者との間の本サービス利用に関わる一切の関係に適用されます。
          開発者が本サービス上で別途定めるルール等（以下「個別規定」）がある場合、個別規定は本規約の一部を構成します。
        </p>

        <h2>第2条（利用登録・アカウント）</h2>
        <p>
          利用者は、開発者が定める方法により利用登録を行う場合があります。
          登録情報に虚偽があった場合、開発者は利用登録を承認しない、または利用を停止することがあります。
        </p>

        <h2>第3条（提供機能）</h2>
        <p>
          本サービスは、タスクやプロジェクト等の管理を目的とした機能を提供します。
          開発者は、利用者に事前通知のうえ、機能の追加・変更・停止を行うことがあります。
        </p>

        <h2>第4条（料金）</h2>
        <p>
          本アプリは現時点で無料で提供され、課金機能（有料プラン、サブスクリプション等）はありません。
          ただし、今後、機能追加等に伴い課金機能を導入する可能性があります。その場合は、事前に周知し、本規約を必要に応じて更新します。
        </p>

        <h2>第5条（広告）</h2>
        <p>
          本アプリは現時点で広告配信を行っていません。ただし、今後、運営上の必要性等により広告を導入する可能性があります。
          その場合、広告配信事業者等の第三者が情報を取得することがあり、開発者はプライバシーポリシー等で周知します。
        </p>

        <h2>第6条（禁止事項）</h2>
        <p>利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>不正アクセス、リバースエンジニアリング等の解析行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>第三者になりすます行為</li>
          <li>他の利用者または第三者の権利・利益を侵害する行為</li>
          <li>その他、開発者が不適切と判断する行為</li>
        </ul>

        <h2>第7条（データの取扱い）</h2>
        <p>
          本サービスの利用に伴い、利用者が入力したタスク等のデータが外部サービス上に保存される場合があります。
          個人情報を含む利用者情報の取扱いは、別途定めるプライバシーポリシーに従います。
        </p>

        <h2>第8条（アカウント削除・退会）</h2>
        <p>
          利用者は、本アプリ内の「設定」等からアカウント削除を行うことができます。
          <strong>端末からアプリを削除しただけでは、外部サービス上のデータが残る場合があります</strong>ので、
          データ削除を希望する場合はアカウント削除をご利用ください。
        </p>

        <h2>第9条（免責）</h2>
        <p>
          開発者は、本サービスの提供にあたり合理的な範囲で安全性・正確性の確保に努めますが、
          本サービスに瑕疵がないことを保証するものではありません。
          開発者の故意または重過失がある場合を除き、本サービスに起因して利用者に生じた損害について責任を負いません。
        </p>

        <h2>第10条（規約の変更）</h2>
        <p>開発者は、必要に応じて本規約を変更することができます。変更後の本規約は、本サービス上の掲示その他適切な方法で周知します。</p>

        <h2>第11条（準拠法・管轄）</h2>
        <p>
          本規約の準拠法は日本法とし、本サービスに関連して紛争が生じた場合、開発者の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
        </p>

        <h2>お問い合わせ</h2>
        <p>
          本サービスに関するお問い合わせは、以下へご連絡ください。
          <br />
          連絡先：haruki2021promoter@gmail.com
        </p>

        <h2>改定日・制定日</h2>
        <p>
          改定日：2026年1月11日
          <br />
          制定日：2026年1月11日
        </p>
      </div>
    </div>
  );
}

export default Terms;
